import { makeAutoObservable } from 'mobx';
import { ReservationDto } from 'services/data-contracts';
import { ReservationDailyFilterType, ReservationPeriodFilterType } from 'types/CommonTypes';
import ServiceHelper from './ServiceHelper';
import { PaginationInfo, getPaginationHeader } from 'libs/helper/paginationUtil';
export interface isValid {
  isValid: boolean;
}

class ReservationFilterStore {
  reservations: ReservationDto[] = [];

  filteredReservations: ReservationDto[] = [];

  page: number = 0;
  size: number = 10;

  periodConditions: ReservationPeriodFilterType;

  dailyConditions: ReservationDailyFilterType;

  paginationInfo: PaginationInfo | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  /**
   * @description 일별 예약 조회
   * @param filter
   */
  getReservationByDaily(filter: ReservationDailyFilterType) {
    this.dailyConditions = filter;
    ServiceHelper.adminReservationService
      ?.getReservations({
        arrivalDate: filter.date,
        departureDate: filter.date,
        page: this.page,
        size: 500,
        sort: ['listingName,desc'],
      })
      .then((res) => {
        this.reservations = res.data;
        this.filteredReservations = res.data;
        this.paginationInfo = getPaginationHeader(res.headers);
      });
  }

  getReservationByPeriod(filter: ReservationPeriodFilterType) {
    this.periodConditions = filter;
    ServiceHelper.adminReservationService
      ?.getReservationsByPeriod({
        fromDate: filter.dateRange[0] ?? '',
        toDate: filter.dateRange[1] ?? '',
        periodType:
          filter.periodType === 'ALL' ? 'RESERVATION' : filter.periodType ?? 'RESERVATION',
        status:
          filter.status === 'ALL'
            ? undefined
            : filter.status === 'COMPLETED'
              ? 'CANCELLED'
              : filter.status,
        searchKeyword: filter.search,
        page: filter.page ? filter.page - 1 : 0,
        size: filter.size ?? 10,
      })
      .then((res) => {
        this.reservations = res.data;
        this.filteredReservations = res.data;
        this.paginationInfo = getPaginationHeader(res.headers);
      });
  }

  setDailiyFilter(filter: ReservationDailyFilterType) {
    this.filteredReservations = this.reservations.filter((reservation) => {
      if (filter.type === 'all') {
        return true;
      }

      if (filter.type === 'arrival') {
        return reservation.arrivalDate === filter.date;
      }

      if (filter.type === 'departure') {
        return reservation.departureDate === filter.date;
      }

      return false;
    });
  }

  setFilterByKeyword(keyword: string) {
    this.filteredReservations = this.reservations.filter((reservation) => {
      const keywordLower = keyword.toLowerCase();
      return (
        reservation.reservationNo?.toLowerCase().includes(keywordLower) ||
        reservation.guest?.profile?.firstName?.toLowerCase().includes(keywordLower) ||
        reservation.guest?.profile?.lastName?.toLowerCase().includes(keywordLower) ||
        reservation.guest?.profile?.phoneNumber?.toLowerCase().includes(keywordLower) ||
        reservation.guest?.username?.toLowerCase().includes(keywordLower) // email field
      );
    });
  }

  unmount() {
    this.reservations = [];
  }
}

export default ReservationFilterStore;
